export const getEnv = () => {
  const { host } = window.location;
  if (host === 'app.guesty.com') {
    return 'production';
  }
  const match = host.match(/app-(\w+)\.guesty\.com/);
  if (match && match[1]) {
    return match[1];
  }
  return process.env.CLUSTER || 'staging';
};

export default { getEnv };
